import { render, staticRenderFns } from "./PageRangeInput.vue?vue&type=template&id=6d433a7f&"
import script from "./PageRangeInput.vue?vue&type=script&lang=js&"
export * from "./PageRangeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports